import { useEffect, useState, useContext } from 'react';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './sumsubAgbk.css'
import { downloadAgbkSumsubReport, fetchAgbkSumsubReports } from 'services/agbkReportsServices';

const SumsubAgbkReports = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchAgbkSumsubReports(user);
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t("pages_name.agbk_report_compliance_sumsub")}>
      <Notification />
      <div className='sumsub_agbk_title_component'>
        <h2>{t("pages.agbk_report_compliance_sumsub.title")}</h2>
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`agbk_sumsub_${file}.xlsx`}
              fetchData={downloadAgbkSumsubReport}
              fetchDataParams={{ user, fileName: file }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default SumsubAgbkReports;